export default __webpack_public_path__ + "static/media/kanye.0dc8affd.jpg";